import App from '@/components/common/AnonymousHeader.vue'
import { bootstrapApp } from "@/bootstrapApp";
bootstrapApp(App, 'nonvr-anonymousheader');
